<template>
  <div id="ylInvestEducation">
    <ylInvestEducationMobile v-if="isMobileScreen" v-bind="$attrs" :list="list" />
    <ylInvestEducationPC v-else v-bind="$attrs" :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylInvestEducation",
  components: {
    ylInvestEducationMobile: () => import("./components/mobile.vue"),
    ylInvestEducationPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.investorEducation()
  },
  methods: {
    async investorEducation() {
      let res = await this.$api.investorEducation()
      this.list = res
    }
  }
};
</script>